import { response } from "express"
import { apiHelper } from "./core"
import { apiHelperCS } from "./core"

const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const clinicalServiceBaseUrl =
  process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

const getTestLatest = (appointmentId: string): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/medicalrecords/${appointmentId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllChemoOrders = (patientId: string, event: string): Promise<any> => {
  return apiHelper
    .get(
      `${clinicalServiceBaseUrl}/chemo-order/patient?patientId=${patientId}&pastOrUpcoming=${event}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Start Chemo Order
const startChemoOrder = (
  therapyId: string,
  chemoOrderId: string,
  appointmentId: string
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${chemoOrderId}/start?appointmentId=${appointmentId}`,
      {}
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//delete chemo order
const deleteChemoOrder = (
  therapyId: string,
  chemoOrderId: string
): Promise<any> => {
  return apiHelper
    .delete(`${clinicalServiceBaseUrl}/chemo-order/${chemoOrderId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//complete chemo order
const completeChemoOrder = (
  payload: any,
  chemoOrderId: string
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${chemoOrderId}/complete`,
      payload
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
//get list of previous cancer order templates in chemo order
const getListCancerOrder = (id: string): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/chemo-order/${id}/previous-chemo-order`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Load a particular Chemo order
const getSelectedChemoOrder = (id: string): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/chemo-order/${id}/load-chemo-order`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//get list type of cancer templates in chemo order
const getListCancerTemplate = (
  type: string,
  centerId: string
): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/form-templates/types?type=${type}&centerId=${centerId}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Get List of consent types
const getListConsentTemplate = (type: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/form-templates/types?type=${type}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//get list type of cancer templates in Forms & Consents
const getListCancerTemplateConsents = (
  type: string,
  id: string
): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/form-templates/types?type=${type}&appointmentId=${id}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//fetch data for a given cancer template
const getDataCancerTemplate = (
  type: string,
  templateName: string
): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/form-templates/${templateName}/json`)
    .then((response) => {
      return response?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Modifying existing and adding new cancer templates
const addNewCancerTemplate = (values: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/form-templates`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getAllDischargeSummary = (patientId: string): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/discharges?patientId=${patientId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllDischargesSummary = (appointmentId: string): Promise<any> => {
  return apiHelper
    .get(`${clinicalServiceBaseUrl}/discharges?appointmentId=${appointmentId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const createDischargeSummary = (values: any): Promise<any> => {
  return apiHelper
    .post(`${clinicalServiceBaseUrl}/discharges`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveDischargeSummary = (values: any): Promise<any> => {
  console.log(values, "valuesss1")
  return apiHelper
    .put(`${clinicalServiceBaseUrl}/discharges/${values?.id}`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateDischargedSummary = (id: any, value: any): Promise<any> => {
  console.log(id, "valuesss2")
  return apiHelper
    .put(`${clinicalServiceBaseUrl}/discharges/${id}`, value)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
// const updateDischargedSummary = (values: any): Promise<any> => {
//   console.log(values, "valuesss2")
//   return apiHelper
//     .put(`${clinicalServiceBaseUrl}/discharges/${values}`, values)
//     .then((res) => {
//       return res?.data
//     })
//     .catch((err) => Promise.reject(err))
// }

const addChemoOrder = (values: any): Promise<any> => {
  return apiHelper
    .post(`${clinicalServiceBaseUrl}/chemo-order`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateChemoOrder = (
  values: any,
  therapyId: any,
  orderId: any
): Promise<any> => {
  return apiHelper
    .put(`${clinicalServiceBaseUrl}/chemo-order/${orderId}`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const addEditableChemoOrder = (therapyId: any, values: any): Promise<any> => {
  console.log(therapyId, values)
  return apiHelper
    .put(`${clinicalServiceBaseUrl}/therapy/${therapyId}/complete`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
// files
const getAllDocumentUrl = (patientId: any): Promise<any> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/patients/${patientId}/documents`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

let count: number = 0

const uploadSpecificFile = (values: any, isPublic: any): Promise<any> => {
  const currentCount = count
  count++
  return apiHelper
    .post(
      `${resourceServiceBaseUrl}/files?isPublic=${
        isPublic ? true : false
      }&count=${currentCount}`,
      values
    )
    .then((res) => {
      count++
      return res?.data
    })
    .catch((err) => {
      count++
      return Promise.reject(err)
    })
}

const uploadAllFiles = (values: any, patientId: any): Promise<any> => {
  return apiHelper
    .put(`${userServiceBaseUrl}/patients/${patientId}/documents`, values)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Documents delete Api
const deleteFile = (info: any): Promise<any> => {
  return apiHelper
    .delete(
      `${userServiceBaseUrl}/patients/${info.patientId}/documents/${info.mocDocumentId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Nursing Notes Api

//save Nurse Notes

const saveNurseNotes = (values: any, appointmentId: any): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/medicalrecords/nurse-notes/${appointmentId}`,
      values
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get completedbyNurse
const getAllStaffDetail = (
  staffType: any,
  centerId: any,
  staffNurse: any
): Promise<any> => {
  return apiHelper
    .get(
      `${userServiceBaseUrl}/staff?primaryRole=${staffType}&centerId=${centerId}&includeSecondaryRoles=${staffNurse}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Get Nurse Notes which are saved

const getSaveNurseNotes = (appointmentId: any): Promise<any> => {
  return apiHelper
    .get(
      `${clinicalServiceBaseUrl}/medicalrecords/nurse-notes?appointmentId=${appointmentId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//get all past appointment Notes
const getPastAppointmentNotes = (
  patientId: any,
  status?: any
): Promise<any> => {
  let url: any = `${clinicalServiceBaseUrl}/medicalrecords/nurse-notes`
  if (patientId) {
    url += `?patientId=${patientId}`
  }
  if (status) {
    url += `&status=${status}`
  }
  return apiHelper
    .get(`${url}`)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//chemo Order Prescription and lab prescription related changes

//Prescription chemo prder
const savePrescriptionChemoOrder = (
  values: any,
  chemoId: any,
  prescriptionType: any,
  prescriptionCount: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${chemoId}/prescription/save?prescriptionType=${prescriptionType}&prescriptionCount=${prescriptionCount}`,
      values
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const updatePrescriptionChemoOrder = (
  values: any,
  chemoId: any,
  prescriptionType: any,
  prescriptionId: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${chemoId}/prescription/update?prescriptionType=${prescriptionType}&prescriptionId=${prescriptionId}`,
      values
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const sendPrescriptionChemoOrder = (
  prescriptionType: any,
  prescriptionId: any,
  chemoId: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${chemoId}/prescription/send?prescriptionType=${prescriptionType}&prescriptionId=${prescriptionId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const cancelPrescriptionChemoOrder = (
  prescriptionType: any,
  prescriptionId: any,
  chemoId: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${chemoId}/prescription/cancel?prescriptionType=${prescriptionType}&prescriptionId=${prescriptionId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//Lab Prescription chemo order
const saveLabPrescriptionChemoOrder = (
  values: any,
  id: any,
  patientId: any
): Promise<any> => {
  delete values?.["addToPrint"]
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/lab-prescription/save?id=${id}&patientId=${patientId}`,
      values
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const updateLabPrescriptionChemoOrder = (
  id: any,
  labPrescriptionId: any,
  values: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${id}/lab-prescription/update/${labPrescriptionId}`,
      values
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const sendLabPrescriptionChemoOrder = (
  id: any,
  labPrescriptionId: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${id}/lab-prescription/send/${labPrescriptionId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const cancelLabPrescriptionChemoOrder = (
  id: any,
  labPrescriptionId: any
): Promise<any> => {
  return apiHelper
    .put(
      `${clinicalServiceBaseUrl}/chemo-order/${id}/lab-prescription/cancel/${labPrescriptionId}`
    )
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

//To get temporary blobUrl for documents
const getBlobUrl = (url: any, skipLoader: any = false): Promise<any> => {
  return apiHelperCS
    .get(`${resourceServiceBaseUrl}/files/append-sas?blobUrl=${url}`, {
      params: { skipLoader },
    })
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

export {
  getSelectedChemoOrder,
  getListCancerOrder,
  getTestLatest,
  addChemoOrder,
  getAllChemoOrders,
  createDischargeSummary,
  getAllDischargeSummary,
  saveDischargeSummary,
  getAllDocumentUrl,
  uploadSpecificFile,
  uploadAllFiles,
  deleteFile,
  saveNurseNotes,
  getSaveNurseNotes,
  getPastAppointmentNotes,
  getListCancerTemplate,
  getDataCancerTemplate,
  addNewCancerTemplate,
  addEditableChemoOrder,
  updateChemoOrder,
  startChemoOrder,
  deleteChemoOrder,
  completeChemoOrder,
  getListCancerTemplateConsents,
  getAllStaffDetail,
  getListConsentTemplate,
  savePrescriptionChemoOrder,
  updatePrescriptionChemoOrder,
  sendPrescriptionChemoOrder,
  cancelPrescriptionChemoOrder,
  saveLabPrescriptionChemoOrder,
  updateLabPrescriptionChemoOrder,
  sendLabPrescriptionChemoOrder,
  cancelLabPrescriptionChemoOrder,
  getAllDischargesSummary,
  updateDischargedSummary,
  getBlobUrl,
}
